import { Collapse, Input, Spin } from "antd";
import { useEffect, useState, useCallback } from "react";
import { fetchPitchings } from "shared/service/StrmService";
import { LoadingOutlined, UpOutlined } from "@ant-design/icons";
import { ReactComponent as SearchIcon } from "shared/assets/images/icon-search-purple.svg";
import { ReactComponent as QuickQuincyIcon } from "shared/assets/images/icon-quincy-side-menu.svg";
import { ReactComponent as DesertIcon } from "shared/assets/images/desert-icon.svg";
import Markdown from "markdown-to-jsx";
import moment from "moment";
// import { useSelector } from "react-redux";
// import { ArtistState } from "explorer/reducers/artistas";

import { useHistory } from "react-router-dom";
import "./PitchingCenter.scss";
import { Trans, useTranslation } from "react-i18next";
import { LinguagemEnum } from "shared/enums/LinguagemEnum";
import LogoPitching from "shared/assets/images/icon-pitching-side-menu.svg";
import { AdvanceWrapper } from "shared/components/smart-wrapper/SmartWrapper";
import { motion } from "motion/react";
import { ArtistFeatureCard } from "shared/components/artist-feature-card/ArtistFeatureCard";

const PitchingCenter = () => {
  const { t, i18n } = useTranslation();
  const history = useHistory();

  const [pitchings, setPitchings] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);
  // const { userArtist } = useSelector((state: ArtistState) => state.artists);

  const formatDate = (date: string) =>
    moment(date).format(
      i18n.language === LinguagemEnum.Portugues ? "DD/MM/YYYY" : "MM/DD/YYYY",
    );

  const fetchData = useCallback(async () => {
    setLoading(true);
    const { response }: any = await fetchPitchings();
    setPitchings(response.items || []);
    setLoading(false);
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const LabelCollapsePitching = ({ pitching }: any) => {
    return (
      <div className="header-item-pitching">
        <div className="col-name-pitching">{pitching.name}</div>
        <div className="col-date-pitching">
          {formatDate(pitching.createdOn)}
        </div>
      </div>
    );
  };

  const DetailPitching = ({ pitching }: any) => {
    return (
      <div className="details">
        <p className="label">{t("pages.CentralPitching.dataCriacao")}</p>
        <p className="value">{formatDate(pitching.createdOn)}</p>
        <p className="label">{t("pages.CentralPitching.dataLancamento")}</p>
        <p className="value">{formatDate(pitching.releaseOn)}</p>
        <p className="label">{t("pages.CentralPitching.pitching")}</p>
        <p className="value">
          {pitching.pitching ? <Markdown>{pitching.pitching}</Markdown> : <></>}
        </p>
      </div>
    );
  };
  const fadeInUp = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 },
  };
  return (
    <AdvanceWrapper>
      <motion.aside
        variants={fadeInUp}
        initial="hidden"
        whileInView="visible"
        transition={{ duration: 0.5, type: "spring", bounce: 0.3 }}
        viewport={{ once: true }}
      >
        <ArtistFeatureCard
          isPageInfo={true}
          title={t("pages.CentralPitching.tituloCard")}
          subtitle={t("pages.CentralPitching.subtituloCard")}
          image={LogoPitching}
        />
      </motion.aside>
      <div>
        <div className="content">
          <motion.h2
            variants={fadeInUp}
            initial="hidden"
            whileInView="visible"
            transition={{ duration: 0.5, type: "spring", bounce: 0.3 }}
            viewport={{ once: true }}
          >
            {t("pages.CentralPitching.title")}
          </motion.h2>
          <motion.p
            variants={fadeInUp}
            initial="hidden"
            whileInView="visible"
            transition={{
              duration: 0.5,
              type: "spring",
              bounce: 0.3,
              delay: 0.2,
            }}
            viewport={{ once: true }}
            className="explanation-pitching"
          >
            <Trans i18nKey="pages.CentralPitching.explicacao" />
          </motion.p>

          <motion.div
            variants={fadeInUp}
            initial="hidden"
            whileInView="visible"
            transition={{
              duration: 0.5,
              type: "spring",
              bounce: 0.3,
              delay: 0.4,
            }}
            viewport={{ once: true }}
            className="quick-pitching"
          >
            <div className="quinncy-title-pitching">
              <QuickQuincyIcon /> Quincy
            </div>
            <div className="quincy-content-pitching">
              <p>{t("pages.CentralPitching.quincyMessage")}</p>
            </div>
            <div className="quincy-footer-pitching">
              <button
                className="quick-button-pitching"
                onClick={() => history.push("/pitching/new")}
              >
                <QuickQuincyIcon /> {t("pages.CentralPitching.criarPitching")}
              </button>
            </div>
          </motion.div>
          <motion.div
            variants={fadeInUp}
            initial="hidden"
            whileInView="visible"
            transition={{
              duration: 0.5,
              type: "spring",
              bounce: 0.3,
              delay: 0.6,
            }}
            viewport={{ once: true }}
            className="my-pitching-list"
          >
            <img src={LogoPitching} alt="pitching" />
            <span>{t("pages.CentralPitching.minhaListaPitching")}</span>
          </motion.div>
          <motion.div
            variants={fadeInUp}
            initial="hidden"
            whileInView="visible"
            transition={{
              duration: 0.5,
              type: "spring",
              bounce: 0.3,
              delay: 0.8,
            }}
            viewport={{ once: true }}
            className="row-search-pitching"
          >
            <Input
              placeholder={t("pages.CentralPitching.pesquisar")}
              suffix={<SearchIcon />}
              onChange={(ev) => setSearch(ev.target.value)}
              disabled={loading}
            />
            {loading ? (
              <div className="loading-search-pitching">
                <Spin indicator={<LoadingOutlined />} />
              </div>
            ) : pitchings.length === 0 ? (
              <div className="no-pitching">
                <div className="icon-no-pitching">
                  <DesertIcon />
                </div>
                <div>
                  <p className="title-no-pitching">
                    {t("pages.CentralPitching.atencao")}
                  </p>
                  <p className="explain-text-no-pitching">
                    {t("pages.CentralPitching.nenhumPitching")}
                  </p>
                </div>
              </div>
            ) : (
              <>
                <div className="row-header-collapse-pitching">
                  <span>{t("pages.CentralPitching.lancamento")}</span>
                  <span>{t("pages.CentralPitching.dataCriacao")}</span>
                </div>

                <div>
                  <Collapse
                    bordered={false}
                    defaultActiveKey={["1"]}
                    expandIcon={({ isActive }) => (
                      <UpOutlined
                        style={{
                          opacity: isActive ? 1 : 0,
                          transition: "all 0.5s ease-in-out",
                        }}
                      />
                    )}
                    className="collapse-pitching"
                    items={pitchings
                      .filter(
                        (x: any) =>
                          !search ||
                          x.name?.toLowerCase().includes(search?.toLowerCase()),
                      )
                      ?.map((pitching: any) => ({
                        key: pitching.id,
                        name: pitching.name,
                        label: <LabelCollapsePitching pitching={pitching} />,
                        children: <DetailPitching pitching={pitching} />,
                      }))}
                    expandIconPosition="end"
                  />
                </div>
              </>
            )}
          </motion.div>
        </div>
      </div>
    </AdvanceWrapper>
  );
};

export default PitchingCenter;
